import React from 'react';
import { useTranslation } from 'react-i18next';

const AuthTabs = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();
  const tabs = [
    { id: 'login', label: t('auth.login') },
    { id: 'register', label: t('auth.register') }
  ];

  return (
    <div className="flex gap-1.5 p-1 bg-muted rounded-lg mb-4 md:mb-5">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          onClick={() => onTabChange(tab?.id)}
          className={`flex-1 py-2 px-3 md:px-4 rounded-md text-sm font-medium transition-all duration-250 ${
            activeTab === tab?.id
              ? 'bg-card text-foreground shadow-elevation-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          aria-selected={activeTab === tab?.id}
          role="tab"
        >
          {tab?.label}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;
